import { isOnlineByHealthChecker } from '@/modules/healthCheck/healthChecker'
import { useNetworkStore } from '@/stores/networkStore'

/**
 * ネットワークの接続状態をチェックするクラス
 */
export class NetworkConnectionChecker {
  private static readonly INTERVAL: number = 1000 * 10
  private static intervalId: NodeJS.Timer | undefined
  private static _instance: NetworkConnectionChecker
  private static get store() {
    return useNetworkStore()
  }

  static get instance(): NetworkConnectionChecker {
    if (NetworkConnectionChecker._instance === undefined) {
      NetworkConnectionChecker._instance = new NetworkConnectionChecker()
    }
    return NetworkConnectionChecker._instance
  }

  /**
   * コネクションのチェックを行う
   */
  private checkConnection(): void {
    isOnlineByHealthChecker()
      .then(result => {
        NetworkConnectionChecker.store.setCanConnectNetwork(result)
      })
      .catch(() => {
        // もしもヘルスチェックに失敗した場合は、オフラインとして扱う
        NetworkConnectionChecker.store.setCanConnectNetwork(false)
      })
  }

  /**
   * コネクションのチェックを開始する
   * @param なし
   */
  public startCheckingConnection(): void {
    NetworkConnectionChecker.intervalId = setInterval(
      this.checkConnection,
      NetworkConnectionChecker.INTERVAL
    )
  }

  /**
   * コネクションのチェックを停止する
   */
  public clearCheckingConnection(): void {
    if (NetworkConnectionChecker.intervalId !== undefined) {
      clearInterval(NetworkConnectionChecker.intervalId as NodeJS.Timeout)
    }
  }
}
